import {I18n} from 'aws-amplify/utils';
import {useParams} from 'react-router-dom';
import {
    Alert,
    Container,
    Text,
    Title,
} from '@mantine/core';

// FNP-1202 placeholder. FNP-1186 registered the zones index and the nested
// records route but no zone detail route, so /zones/:zoneId matched nothing
// and produced "No route matches URL". FNP-1192 reaches Records from a zone's
// detail view, so this route is the parent that link hangs off.
// FNP-1191 replaces this file with the real detail page.
export const DetailPlaceholderPage = () => {

    const {zoneId} = useParams();

    return (
        <Container p={'xl'}>
            <Title order={2} mb={'md'}>{I18n.get('Zone')}</Title>
            <Alert title={I18n.get('Not built yet')}>
                <Text>{I18n.get('This module is registered but not yet implemented. It arrives with FNP-1191.')}</Text>
                <Text mt={'xs'}>{I18n.get('Zone')}: {zoneId}</Text>
            </Alert>
        </Container>
    );
};
